export default __webpack_public_path__ + "static/team-jessica-b4b4dbd70b9e7ee5984094e7afa6096b.png";